module.exports = __webpack_public_path__ + "static/media/hamburger.98fb8260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hamburger.svg
// module id = 16
// module chunks = 0